<template>
  <q-dialog v-model="visible" persistent>
    <q-card class="container">
      <div class="modal-header">
        <q-card-section class="header">
          <div class="header-content-wrapper">
            <div class="header-title">{{ titulo }}</div>
            <q-btn flat round color="white" icon="close" @click="onClose" class="header-close-btn" />
          </div>
        </q-card-section>
      </div>

      <div class="modal-body">
        <div class="content">
          <div v-if="loading" class="loading-section">
            <q-inner-loading :showing="loading">
              <q-spinner-gears size="80px" color="primary" />
            </q-inner-loading>
          </div>

          <div v-if="hasError" class="text-negative text-center q-pa-md">
            {{ errorMessage }}
          </div>

          <div v-else-if="!loading && agendamentoData">
            <!-- Board Hoje -->
            <div class="day-board">
              <div class="day-board-content">
                <!-- Seção Hoje -->
                <div class="day-header">Hoje - {{ agendamentoData.hoje.data }}</div>

                <!-- Próxima Coleta -->
                <div class="card-hoje">
                  <div class="proxima-coleta-title">{{ this.$gettext('INDUSTRIAL_MAP_SCHEDULE_NEXT_COLLECTION') }}: {{ agendamentoData.hoje.proximaColeta.nomeRota }}</div>
                  <div class="info-grid">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_DEPARTURE_TIME') }}</div>
                      <div class="info-value">{{ agendamentoData.hoje.proximaColeta.horarioPartida }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_RESPONSIBLE') }}</div>
                      <div class="info-value">{{ agendamentoData.hoje.proximaColeta.responsavel }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_VEHICLE') }}</div>
                      <div class="info-value">{{ agendamentoData.hoje.proximaColeta.veiculo }}</div>
                    </div>
                    <div class="info-row full-width">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_WASTES') }}</div>
                      <div class="info-value">{{ agendamentoData.hoje.proximaColeta.residuos.join(', ') }}</div>
                    </div>
                  </div>
                </div>

                <!-- Rotas Hoje (Acordeões) -->
                <div class="rotas-section">
                  <q-expansion-item
                    v-for="(rota, index) in agendamentoData.hoje.rotas"
                    :key="index"
                    class="rota-expansion"
                    header-class="text-white"
                    expand-icon-class="text-white"
                  >
                    <template v-slot:header>
                      <div class="rota-header">
                        <q-icon name="event" size="20px" class="q-mr-sm" />
                        <span>{{ rota.data }}</span>
                      </div>
                    </template>

                    <q-card>
                      <q-card-section class="rota-content">
                        <!-- Informações da Rota -->
                        <div class="rota-info-title">{{ rota.nomeRota }}</div>
                        <div class="info-grid">
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_DEPARTURE_TIME') }}</div>
                            <div class="info-value">{{ rota.horarioPartida }}</div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_RESPONSIBLE') }}</div>
                            <div class="info-value">{{ rota.responsavel }}</div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_VEHICLE') }}</div>
                            <div class="info-value">{{ rota.veiculo }}</div>
                          </div>
                        </div>

                        <!-- Pontos de Coleta -->
                        <div class="pontos-coleta-list">
                          <div
                            v-for="(ponto, pIndex) in rota.pontosColeta"
                            :key="pIndex"
                            class="ponto-coleta-item"
                          >
                            <div class="ponto-coleta-header">{{ this.$gettext('INDUSTRIAL_MAP_SCHEDULE_COLLECTION_POINT') }} {{ ponto.numero }}:</div>
                            <div class="ponto-coleta-residuos">{{ ponto.residuos.join(', ') }}</div>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </q-expansion-item>
                </div>
              </div>
            </div>

            <!-- Board Amanhã -->
            <div class="day-board">
              <div class="day-board-content">
                <!-- Seção Amanhã -->
                <div class="day-header">{{ this.$gettext('INDUSTRIAL_MAP_SCHEDULE_TOMORROW') }} - {{ agendamentoData.amanha.data }}</div>

                <!-- Rotas Amanhã (Acordeões) -->
                <div class="rotas-section">
                  <div v-if="agendamentoData.amanha.rotas.length === 0" class="no-rotas-message">
                    {{ this.$gettext('INDUSTRIAL_MAP_SCHEDULE_NO_ROUTES_TOMORROW') }}
                  </div>
                  <q-expansion-item
                    v-for="(rota, index) in agendamentoData.amanha.rotas"
                    :key="index"
                    class="rota-expansion"
                    header-class="text-white"
                    expand-icon-class="text-white"
                  >
                    <template v-slot:header>
                      <div class="rota-header">
                        <q-icon name="event" size="20px" class="q-mr-sm" />
                        <span>{{ rota.data }}</span>
                      </div>
                    </template>

                    <q-card>
                      <q-card-section class="rota-content">
                        <!-- Informações da Rota -->
                        <div class="rota-info-title">{{ rota.nomeRota }}</div>
                        <div class="info-grid">
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_DEPARTURE_TIME') }}</div>
                            <div class="info-value">{{ rota.horarioPartida }}</div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_RESPONSIBLE') }}</div>
                            <div class="info-value">{{ rota.responsavel }}</div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_VEHICLE') }}</div>
                            <div class="info-value">{{ rota.veiculo }}</div>
                          </div>
                        </div>

                        <!-- Pontos de Coleta -->
                        <div class="pontos-coleta-list">
                          <div
                            v-for="(ponto, pIndex) in rota.pontosColeta"
                            :key="pIndex"
                            class="ponto-coleta-item"
                          >
                            <div class="ponto-coleta-header">{{ this.$gettext('INDUSTRIAL_MAP_SCHEDULE_COLLECTION_POINT') }} {{ ponto.numero }}:</div>
                            <div class="ponto-coleta-residuos">{{ ponto.residuos.join(', ') }}</div>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </q-expansion-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <q-card-actions align="center" class="footer">
          <q-btn :label="$gettext('INDUSTRIAL_MAP_BTN_CLOSE')" color="grey-7" class="btn-fechar" @click="onClose" />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IndustrialMapRepository } from 'src/modules/industry/industrial-map/IndustrialMapRepository.js'
import moment from 'moment'

@Component({
  name: 'ModalAgendamentos'
})
class ModalAgendamentos extends Vue {
  @Prop({ type: Boolean, default: false })
  value

  @Prop({ type: Object, default: null })
  posto

  loading = false
  hasError = false
  errorMessage = ''
  agendamentoData = null

  get visible () {
    return this.value
  }

  set visible (val) {
    this.$emit('input', val)
  }

  get titulo () {
    if (this.agendamentoData) {
      return `Agendamentos | ${this.agendamentoData.postoNome}`
    }
    return 'Agendamentos'
  }

  onClose () {
    this.visible = false
    this.$emit('close')
  }

  @Watch('visible')
  async onModalOpen (isVisible) {
    if (isVisible && this.posto && this.posto.id) {
      await this.loadAgendamentos()
    }
  }

  async loadAgendamentos () {
    try {
      this.loading = true
      // Usar o método findDetalharScheduled do service
      const response = await IndustrialMapRepository.findDetalharScheduled(this.posto.id)

      if (response && (response.dadosForm || (response.detalhes && response.detalhes.dadosForm))) {
        // Processar dados da API para o formato esperado pelo modal
        this.agendamentoData = this.processAgendamentosData(response)
        this.hasError = false
        this.errorMessage = ''
      } else {
        this.hasError = true
        this.errorMessage = 'Não foi possível carregar os agendamentos para este posto.'
      }
    } catch (error) {
      this.hasError = true
      this.errorMessage = 'Erro ao carregar agendamentos: ' + error.message
      console.error('Erro ao carregar agendamentos:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_SCHEDULES')
      })
    } finally {
      this.loading = false
    }
  }

  /**
   * Processa os dados da API findDetalharScheduled para o formato esperado pelo modal
   * @param {Object} response - Resposta da API
   * @returns {Object} Dados formatados para o modal
   */
  processAgendamentosData (response) {
    // Lidar com diferentes estruturas de resposta
    const dadosForm = response.dadosForm || (response.detalhes && response.detalhes.dadosForm) || {}

    // Extrair nome do posto
    const postoNome = dadosForm.name || 'Posto Avançado'

    // Processar agendamentos de hoje e próximos dias
    const hoje = moment().format('YYYY-MM-DD')
    const amanha = moment().add(1, 'day').format('YYYY-MM-DD')

    const rotasHoje = []
    const rotasAmanha = []
    let proximaColetaHoje = null

    // Processar industrialTasks se existir
    if (dadosForm.industrialTasks && Array.isArray(dadosForm.industrialTasks)) {
      dadosForm.industrialTasks.forEach((task, index) => {
        // Parse da data com diferentes formatos possíveis
        let momentDate
        if (task.scheduledDate.includes(' ')) {
          // Formato: "2025-10-31 05:07:39.0"
          momentDate = moment(task.scheduledDate, 'YYYY-MM-DD HH:mm:ss')
        } else {
          // Outros formatos possíveis
          momentDate = moment(task.scheduledDate)
        }

        const dataTask = momentDate.format('YYYY-MM-DD')
        const horaTask = momentDate.format('HH:mm')

        // Agrupar resíduos por acondicionamento
        const residuosPorAcondicionamento = {}
        if (task.industrialTaskItems) {
          task.industrialTaskItems.forEach(item => {
            const acondicionamento = item.industrialPacking || 'Não especificado'
            if (!residuosPorAcondicionamento[acondicionamento]) {
              residuosPorAcondicionamento[acondicionamento] = []
            }
            residuosPorAcondicionamento[acondicionamento].push(item.product)
          })
        }

        // Criar pontos de coleta (um por acondicionamento)
        const pontosColeta = Object.entries(residuosPorAcondicionamento).map(([acondicionamento, residuos], index) => ({
          numero: index + 1,
          acondicionamento,
          residuos: [...new Set(residuos)] // Remove duplicatas
        }))

        // Criar objeto da rota
        const rota = {
          id: task.id,
          data: momentDate.format('DD/MM/YYYY'),
          nomeRota: task.route || 'Rota não especificada',
          horarioPartida: horaTask,
          responsavel: task.responsibleName || 'Não especificado',
          veiculo: `Placa: ${task.plate || 'N/A'}`,
          pontosColeta
        }

        // Distribuir por dia
        if (dataTask === hoje) {
          rotasHoje.push(rota)

          // Definir próxima coleta (primeira da lista ordenada)
          if (!proximaColetaHoje || horaTask < proximaColetaHoje.horarioPartida) {
            proximaColetaHoje = {
              nomeRota: rota.nomeRota,
              horarioPartida: rota.horarioPartida,
              responsavel: rota.responsavel,
              veiculo: rota.veiculo,
              residuos: pontosColeta.flatMap(p => p.residuos)
            }
          }
        } else if (dataTask === amanha) {
          rotasAmanha.push(rota)
        } else {
          // Verificar se é uma data futura (além de amanhã)
          const diasDiferenca = momentDate.diff(moment(), 'days')
          if (diasDiferenca > 1) {
            // É uma data futura além de amanhã - adicionar em uma seção futura ou amanhã por enquanto
            rotasAmanha.push(rota)
          }
        }
      })
    }

    // Ordenar rotas por horário
    rotasHoje.sort((a, b) => a.horarioPartida.localeCompare(b.horarioPartida))
    rotasAmanha.sort((a, b) => a.horarioPartida.localeCompare(b.horarioPartida))

    // Se não há próxima coleta hoje, usar placeholder
    if (!proximaColetaHoje) {
      proximaColetaHoje = {
        nomeRota: 'Nenhuma coleta programada',
        horarioPartida: '--:--',
        responsavel: '--',
        veiculo: '--',
        residuos: []
      }
    }

    return {
      postoNome,
      hoje: {
        data: moment().format('DD/MM/YYYY'),
        proximaColeta: proximaColetaHoje,
        rotas: rotasHoje
      },
      amanha: {
        data: moment().add(1, 'day').format('DD/MM/YYYY'),
        rotas: rotasAmanha
      }
    }
  }
}

export default ModalAgendamentos
</script>

<style lang="stylus" scoped>
.container
  width: 920px
  max-width: 920px
  height: 640px
  max-height: 640px
  border-radius: 10px
  padding-top: 16px
  background: white
  display: flex
  flex-direction: column
  gap: 20px
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)

.modal-header
  flex-shrink: 0

.header
  height: 50px
  padding: 8px 20px
  border-radius: 4px
  color: white !important
  flex-shrink: 0
  background-color: #1E4971

.header-content-wrapper
  width: 856px
  height: 34px
  gap: 20px
  display: flex
  align-items: center
  justify-content: space-between
  margin: 0 auto

.header-title
  height: 34px
  font-family: Roboto
  font-weight: 700
  font-style: Bold
  font-size: 28px
  line-height: 34px
  flex-grow: 1

.header-close-btn
  flex-shrink: 0
  cursor: pointer
  margin: 0

.modal-body
  height: 544px
  overflow-y: auto
  padding: 0px 16px 0px 0px

.content
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  padding: 0px 0px 0px 16px
  width: 888px

.modal-footer
  flex-shrink: 0

.footer
  height: 60px
  gap: 20px
  padding: 12px 0
  background: #FFFFFF
  display: flex
  justify-content: center
  align-items: center
  flex-shrink: 0

.day-board
  width: 888px
  border: 1px solid #E0E0E0
  border-radius: 8px
  margin-bottom: 16px
  background: #FCFCFC

.day-board-content
  padding: 16px

.day-header
  font-size: 18px
  font-weight: 500
  color: #424242
  margin-bottom: 12px

.card-hoje
  border-radius: 8px
  padding: 12px
  border-left: 3px solid #0679CC
  background: #FFFFFF
  margin-bottom: 8px

.proxima-coleta-title
  font-size: 18px
  font-weight: 500
  color: #424242
  margin-bottom: 12px

.info-grid
  display: grid
  grid-template-columns: repeat(3, 1fr)
  gap: 8px

.info-row
  display: flex
  background: #f2f2f2
  border-radius: 4px
  padding: 8px 12px
  align-items: center

.info-row.full-width
  grid-column: 1 / -1

.info-label
  font-weight: 500
  color: #0f5295
  min-width: 100px
  margin-right: 8px
  font-size: 14px

.info-value
  color: #424242
  flex: 1
  font-size: 14px

.rotas-section
  display: flex
  flex-direction: column
  gap: 8px

.rota-expansion
  background-color: #0F5295
  border-radius: 4px
  margin-bottom: 8px

.rota-header
  display: flex
  align-items: center
  width: 100%
  color: white
  font-size: 16px
  font-weight: 500

.rota-content
  padding: 12px
  background: white

.rota-info-title
  font-size: 16px
  font-weight: 500
  color: #424242
  margin-bottom: 12px

.pontos-coleta-list
  margin-top: 16px
  display: flex
  flex-direction: column
  gap: 8px

.ponto-coleta-item
  display: flex
  align-items: center
  gap: 8px
  padding: 8px
  background: #F5F5F5
  border-radius: 4px

.ponto-coleta-header
  font-weight: 500
  color: #616161
  font-size: 14px
  min-width: 100px

.ponto-coleta-residuos
  color: #424242
  font-size: 14px
  flex: 1

.btn-fechar
  width: 120px

.loading-section
  min-height: 200px
  display: flex
  align-items: center
  justify-content: center
  padding-top: 40px
  padding-bottom: 40px
  flex-grow: 1

.no-rotas-message
  padding: 20px
  text-align: center
  color: #616161
  font-style: italic
  background: #F5F5F5
  border-radius: 4px
  margin-bottom: 8px
</style>
